import { render, staticRenderFns } from "./KPIFormMenu.vue?vue&type=template&id=64c8d07a&scoped=true"
import script from "./KPIFormMenu.vue?vue&type=script&lang=js"
export * from "./KPIFormMenu.vue?vue&type=script&lang=js"
import style0 from "./KPIFormMenu.vue?vue&type=style&index=0&id=64c8d07a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c8d07a",
  null
  
)

export default component.exports